"use client";
import ScreenLayout from "@/components/layout/screen-layout";

function HeadingSectionWeDevelop() {
  return (
    <ScreenLayout>
      <div className="relative">
        <div
          className="text-center space-y-4"
        >
          <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-semibold leading-[1.1]">
            <span className="bg-gradient-to-r from-[#5231E7] to-[#764AF1] bg-clip-text text-transparent">
              Custom
            </span>{" "}
            <span className="text-gray-900">
              Software Development
            </span>{" "}
            <br />
            <span className="text-gray-900">
              for Startups & Businesses
            </span>
          </h1>
        </div>
      </div>
    </ScreenLayout>
  );
}

export default HeadingSectionWeDevelop;
